import * as types from "./mutation-types";

const setList = async ({commit}, obj) => {
  const { data } = await axios.get(`${process.env.API_PATH}/periodo`)
  commit(types.SET_LIST, {list : data})
}

const savePeriodo = async ({commit}, obj) => {
  const { data } = await axios.post(`${process.env.API_PATH}/periodo` ,obj )
  commit(types.SET_LIST, {periodo : data})
}


export default {
  setList,savePeriodo
}



// WEBPACK FOOTER //
// ./src/features/Periodo/store/actions.js